<script>

    import Moment from 'moment'
    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import DateRangeNav from '../$components/date.range.nav.svelte'
    import Tabs from '../$components/tabs.svelte'
    import QuotationsSummary from './component.quotations.summary.svelte'
    import QuotationsFunnel from './component.quotations.funnel.svelte'
    import QuotationsComparison from './component.quotations.comparison.svelte'
    import QuotationsHistory from './component.quotations.history.svelte'
    import QuotationsUsers from './component.quotations.users.svelte'

    if (!isPermission($adminStore, 'QuotationsView'))
        replace('/404')

    let dateStart = Moment().startOf('month').startOf('day').toDate()
    let dateEnd = Moment().endOf('month').endOf('day').toDate()

    const tabs = [
        { key: 'summary', name: 'Resumen', icon: 'chart-bar' },
        { key: 'history', name: 'Historial', icon: 'history' },
        { key: 'users', name: 'Usuarios', icon: 'users' },
    ]

    let tab = 'summary'

</script>

<style>
    .toolbar {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 1rem;
    }
</style>

<View>
    <PageHeader title="Cotizaciones" subtitle="Comportamiento de los usuarios al cotizar y generar guías" />

    <!-- Usuarios muestra totales históricos y KPIs de 30 días: no usa el rango -->
    {#if tab !== 'users'}
        <div class="toolbar">
            <DateRangeNav bind:dateStart bind:dateEnd />
        </div>
    {/if}

    <Tabs options={ tabs } bind:selected={ tab } />

    {#if tab === 'summary'}
        <div class="columns is-multiline">
            <div class="column is-5">
                <QuotationsSummary { dateStart } { dateEnd } />
            </div>
            <div class="column is-7">
                <QuotationsFunnel { dateStart } { dateEnd } />
            </div>
        </div>

        <div class="columns is-multiline">
            <div class="column is-12">
                <QuotationsComparison title="Comparativa por paquetería" label="Paquetería" source="providers" { dateStart } { dateEnd } />
            </div>
            <div class="column is-12">
                <QuotationsComparison title="Comparativa por proveedor" label="Proveedor" source="partners" { dateStart } { dateEnd } />
            </div>
        </div>
    {:else if tab === 'history'}
        <QuotationsHistory { dateStart } { dateEnd } />
    {:else}
        <QuotationsUsers />
    {/if}
</View>
